import { render, staticRenderFns } from "./marksStaff.vue?vue&type=template&id=0eb0eb38&scoped=true&"
import script from "./marksStaff.vue?vue&type=script&lang=js&"
export * from "./marksStaff.vue?vue&type=script&lang=js&"
import style0 from "./marksStaff.vue?vue&type=style&index=0&id=0eb0eb38&lang=scss&scoped=true&"
import style1 from "./marksStaff.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksStaff.vue?vue&type=style&index=2&id=0eb0eb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb0eb38",
  null
  
)

export default component.exports